/**
 * Runtime helpers for the response envelope shared with the backend
 * (app/schemas/common.py).
 *
 * The envelope shapes themselves (ApiSuccess, ApiPaginated, PaginationMeta)
 * are plain objects and need no declaration in JavaScript:
 *
 *   success: boolean, message: string, data: <payload>, meta: object
 *
 * Paginated responses carry meta = { page, page_size, total_items,
 * total_pages, has_next, has_previous }.
 */

/** Normalised error thrown by the API client. */
export class ApiError extends Error {
  /**
   * @param {string} message
   * @param {{ status: number, code?: string, errors?: Array<object>, requestId?: string }} options
   */
  constructor(message, options) {
    super(message);
    this.name = 'ApiError';
    this.status = options.status;
    this.code = options.code ?? 'UNKNOWN_ERROR';
    this.errors = options.errors ?? [];
    this.requestId = options.requestId;
  }

  /** Field name -> first error message, ready for form binding. */
  get fieldErrors() {
    return this.errors.reduce((acc, error) => {
      if (error.field && !acc[error.field]) acc[error.field] = error.message;
      return acc;
    }, {});
  }
}
